module.exports = __webpack_public_path__ + "static/media/camera_white_circle.bd4d4008.svg";